const ANDROID = 'android';
const IOS = 'ios';
const IPAD = 'ipad';
const DESKTOP = 'desktop';

export function getDevicePlatform() {
    const userAgent: string = navigator.userAgent;

    if (/android/i.test(userAgent)) {
        return ANDROID;
    }

    if (/iPad|iPhone|iPod/i.test(userAgent)) {
        return IOS;
    }

    if (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 0) {
        return IPAD;
    }

    if (/Windows/i.test(userAgent) || /Macintosh/i.test(userAgent)) {
        return DESKTOP;
    }

    return DESKTOP;
}

export function isAndroidDevice() {
    const devicePlatform = getDevicePlatform();

    return devicePlatform === ANDROID;
}

export function isIosDevice() {
    const devicePlatform = getDevicePlatform();

    return [IOS, IPAD].includes(devicePlatform);
}

export function isMobileOrTabletDevice() {
    const devicePlatform = getDevicePlatform();

    return [ANDROID, IOS, IPAD].includes(devicePlatform);
}

export function isDesktopDevice() {
    const devicePlatform = getDevicePlatform();

    return devicePlatform === DESKTOP;
}
